import styled, { css } from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const ShareContainer = styled.div<{ isOpen: boolean }>`
  position: relative;
  margin: 0 1rem 0 auto;

  ${mq.large} {
    margin-right: 0;
  }

  ${props =>
    props.isOpen
      ? css`
          ${ShareMenu} {
            transform: translate3d(0, 0, 0);
            transition-timing-function: ${theme.ease.out};
            transition-delay: 0.2s;
          }

          ${ShareButton} {
            opacity: 0;
            transition-delay: 0s;
          }
        `
      : css``};
`

export const ShareButton = styled.button`
  ${styleReset}
  cursor: pointer;
  display: block;
  /* padding: 0.8rem; */
  padding: 0 0 0 1rem;
  font: inherit;
  font-size: 2.4rem;
  text-transform: uppercase;
  transition: 0.3s opacity 0.55s;

  ${mq.large} {
    font-size: 3rem;
  }

  svg {
    display: block;
  }

  &:hover,
  &:focus-visible {
    text-decoration: underline;
    color: ${theme.colors.accent.primary};
  }
`

export const ShareMenuWrapper = styled.div``

export const ShareMenu = styled.ul`
  margin: 1.5rem 0 0;
  padding: 0;
  list-style: none;

  li {
    display: inline;
    padding: 0;
    margin: 0;
  }

  a {
    display: inline-block;
    font-size: 4rem;
    width: 1em;
    height: 1em;
    margin: 0 0.2em;
    color: white;
    transition: all 0.3s;
    overflow: hidden;
    background: linear-gradient(
        to top,
        ${theme.colors.accent.secondary} 50%,
        ${theme.colors.accent.primary} 50%
      )
      50% 0/100% 200%;

    svg {
      display: block;
    }

    &:hover,
    &:focus {
      background-position: 50% 100%;
    }
  }

  ${mq.smallOnly} {
    display: flex;
    justify-content: center;
    gap: 3rem;
    margin: 1rem 0;

    a {
      display: block;
      height: auto;
      margin: 0;
      width: 3rem;
    }

    svg {
      width: 100%;
      display: block;
    }
  }
`

export const CloseButton = styled.li`
  margin-top: -0.1em;
  padding: 0.8rem;

  button {
    ${styleReset}
    display: block;
    position: relative;
    cursor: pointer;
    width: 1.6rem;
    height: 1.6rem;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      border-top: 2px solid currentColor;
      transform: rotateZ(45deg);
    }

    &::after {
      transform: rotateZ(-45deg);
    }
  }

  ${mq.ltLarge} {
    button::before,
    button::after {
      border-top-color: white;
    }
  }
`
